import { getField, updateField } from 'vuex-map-fields'
import getImportRunFiltersModel from './models/importRunFilters'

const importRunFilters = {
  namespaced: true,
  state: {
    ...getImportRunFiltersModel()
  },
  getters: {
    getField,
    getSearchObject (state) {
      return state
    }
  },
  actions: {
    clearFilters ({ commit }) {
      return commit('clearFilters')
    }
  },
  mutations: {
    updateField,
    clearFilters (state) {
      const model = getImportRunFiltersModel()
      Object.keys(model).forEach(key => { state[key] = model[key] })
    }
  }
}

export default importRunFilters
